import {
  Box,
  Typography as Typo,
  styled,
  TypographyProps,
  Card,
} from '@mui/material';
import {WhiteArrowRight, ArrowRight} from '@jobseeker/lotus/icons';
import {Image} from '@jobseeker/lotus/components/Image';

const StyledCard = styled(Card)({
  height: 'auto',
  overflow: 'visible',
});

const Typography = styled(Typo)<TypographyProps>(({}) => ({
  display: 'flex',
  alignItems: 'center',
}));

type NavigationPanelProps = {
  title: string | JSX.Element;
  menu: Array<{label: string; key: string | number}>;
  selectedItem?: string | number | undefined;
  onSelect: (item: string | number) => void;
};

const NavigationComponent = ({
  title,
  menu,
  selectedItem,
  onSelect,
}: NavigationPanelProps) => {
  const Header = () => (typeof title !== 'string' ? title : <></>);
  return (
    <>
      <StyledCard
        sx={{
          px: 1,
          py: 3,
          width: {md: 226},
          height: 'fit-content',
          boxShadow: '0px 6.48px 6px 2px rgba(41, 41, 41, 0.02)',
          borderRadius: 4,
        }}
      >
        <Box>
          {typeof title === 'string' && (
            <Typography
              display="flex"
              fontSize={16}
              fontWeight={500}
              mb={1}
              mx={1}
              sx={{
                wordWrap: 'break-word',
                textTransform: 'capitalize',
              }}
            >
              {title}
            </Typography>
          )}
          <Header />
        </Box>
        <Box
          display={'flex'}
          flexDirection={'column'}
          justifyContent={'center'}
          rowGap={1}
        >
          {menu.map(item => (
            <Box
              display={'flex'}
              justifyContent={'space-between'}
              alignItems={'center'}
              onClick={() => onSelect(item.key)}
              sx={{
                backgroundColor:
                  selectedItem === item.key ? '#333333' : '#FFFFFF',
                color: selectedItem === item.key ? '#FFFFFF' : '#333333',
                borderRadius: selectedItem === item.key ? '12px' : '0px',
                padding: '8px 16px 8px 8px',
                cursor: 'pointer',
              }}
              data-testid={`navigation-item-${item.key}`}
            >
              <Typography
                variant="subtitle2"
                fontSize={{xxs: 16, md: 14}}
                fontWeight={selectedItem === item.key ? 500 : 400}
              >
                {item.label}
              </Typography>
              <Image
                src={selectedItem === item.key ? WhiteArrowRight : ArrowRight}
                alt={'Drop_Down_Arrow'}
                width={12}
                height={12}
                objectFit="cover"
              />
            </Box>
          ))}
        </Box>
      </StyledCard>
    </>
  );
};

export default NavigationComponent;
